<template>
<div>
  <div class="col-md-4 offset-md-4">
    <div class="row justify-content-center">
      <form @submit.prevent="changepass">
        <div>
          <b-input @input="onInput" type="password" ref="password1" name="password1" v-model="form.password1" placeholder="Пароль" autocomplete="new-password" :state="form_valid1"/>
          <b-input @input="onInput" type="password" ref="password2" name="password2" v-model="form.password2" placeholder="Пароль" autocomplete="new-password" :state="form_valid2"/>
        </div>
        <p class="alert-danger" v-if="$store.state.password_changed_error" id="error">{{ $store.state.password_changed_error }}</p>
        <b-button v-if="!$store.state.password_changed" variant="primary" type="submit" :disabled="submitDisabled">Изменить пароль</b-button>
        <b-button v-else variant="success" type="submit" disabled>Пароль изменен</b-button>
      </form>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "AccountView",
  data() {
    return {
      form: {
        password1: "",
        password2: "",
      },
      form_valid1: null,
      form_valid2: null,
      submitDisabled: true
    };
  },
  methods: {
    changepass: function (){
      this.$store.dispatch('setPassChanged', false)
      this.$store.dispatch('setPassChangedError', null)
      this.$store.dispatch('passChange',
          {'password1': this.form.password1, 'password2': this.form.password2})
    },
    onInput: function (){
      console.log('onInput')
      if (this.form.password1.length > 0 && this.form.password2.length > 0){
          if (this.form.password2 !== this.form.password1){
            this.form_valid2 = false
            this.submitDisabled = true
          } else {
            this.form_valid1 = true
            this.form_valid2 = true
            this.submitDisabled = false
          }

      }
    }
  },
  mounted() {
    this.$store.dispatch('setPassChanged', false)
    this.$store.dispatch('setPassChangedError', null)
  }
}
</script>

<style scoped>

</style>